import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { ECOMMERCE_COINS } from '../../icons/ECOMMERCE_COINS.js';
import { PromotionBadge as PromotionBadge$2, PromotionIconWrapper, PromotionLabel } from './PromotionBadge.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';

var _excluded = ["className", "promotion", "siteId", "urgency", "type", "fullWidthBg"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PromotionBadge = function PromotionBadge(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    promotion = _ref.promotion;
    _ref.siteId;
    var _ref$urgency = _ref.urgency,
    urgency = _ref$urgency === void 0 ? 'Low' : _ref$urgency,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Campaign' : _ref$type,
    _ref$fullWidthBg = _ref.fullWidthBg,
    fullWidthBg = _ref$fullWidthBg === void 0 ? false : _ref$fullWidthBg,
    rest = _objectWithoutProperties(_ref, _excluded);
  var variant = {
    type: {
      CAMPAIGN: 'Campaign',
      GENERAL: 'General'
    },
    urgency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High'
    },
    bgcolors: {
      YELLOW: 'yellow',
      GREEN: 'green',
      BLACK: 'black',
      ORANGE: 'orange',
      RED: 'red'
    },
    fillcolors: {
      BLACK: 'black',
      WHITE: 'white'
    }
  };
  var getVariant = function getVariant() {
    if (type === variant.type.CAMPAIGN) {
      switch (urgency) {
        case variant.urgency.LOW:
          return variant.bgcolors.YELLOW;
        case variant.urgency.MEDIUM:
          return variant.bgcolors.ORANGE;
        case variant.urgency.HIGH:
          return variant.bgcolors.RED;
        default:
          return variant.bgcolors.YELLOW;
      }
    }
    if (type === variant.type.GENERAL) {
      switch (urgency) {
        case variant.urgency.MEDIUM:
          return variant.bgcolors.BLACK;
        case variant.urgency.HIGH:
          return variant.bgcolors.RED;
        default:
          return variant.bgcolors.BLACK;
      }
    }
    return variant.bgcolors.YELLOW;
  };
  var currentVariant = getVariant();
  return /*#__PURE__*/jsxs(PromotionBadge$2, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    children: [/*#__PURE__*/jsxs(PromotionIconWrapper, {
      // @ts-ignore
      variant: currentVariant,
      fullWidthBg: fullWidthBg,
      children: [/*#__PURE__*/jsx(Icon, {
        path: ECOMMERCE_COINS,
        size: "s",
        sizeMobile: "s",
        className: "PromotionIcon"
      }), fullWidthBg && /*#__PURE__*/jsx(PromotionLabel, {
        // @ts-ignore
        variant: currentVariant,
        fullWidthBg: fullWidthBg,
        children: promotion
      })]
    }), !fullWidthBg && /*#__PURE__*/jsx(PromotionLabel, {
      children: promotion
    })]
  }));
};
var PromotionBadge$1 = PromotionBadge;

export { PromotionBadge$1 as default };
//# sourceMappingURL=PromotionBadge.js.map
